<template>
  <div class="animated fadeIn">
    <!-- <div class="splash" v-if="!preloadDone">
      <div class="container d-flex h-100">
        <div
          class="row justify-content-center text-primary w-100 align-self-center text-white"
        >
          <i class="fa fa-spin fa-spinner"></i>
        </div>
      </div>
    </div> -->
    <div class="container mt-3">
      <div class="table-caption">Operadores</div>
      <template>
        <div>
          <b-card>
            <Grid name="OperatorsGrid" v-bind:url="url" v-bind:columns="columns" :pageable='true' v-bind:pagesize="pagesize" :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
          </b-card>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'

export default {
  name: 'OperatorsGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        }
      },
      pagesize: 30,
      url: 'stars/operators',
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '100px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '50px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '260px'
      },
      {
        field: 'nif',
        title: 'NIF',
        width: '130px'
      },
      {
        field: 'codle',
        title: 'codle',
        width: '130px'
      },
      {
        field: 'zip_code',
        title: 'Código Postal'
      },
      {
        field: 'operator_group_id',
        title: 'Operador',
        width: '50px'
      },
      {
        field: 'operatorgroup.data.name',
        title: 'Descrição Operator',
        width: '180px'
      }
      ]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      var route = router.resolve({
        name: 'operators.OperatorsEdit',
        params: {
          id: item.id
        }
      })
      if (this.$auth.check('operators.OperatorsEdit')) {
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// operatorsGrid.vue?3da2d5ef